import React from 'react';
import { FaHeadset, FaTruck, FaShieldAlt, FaMapMarkedAlt } from 'react-icons/fa';
import './TrustStrip.css';

const items = [
  { icon: <FaHeadset />, title: '7/24 Destek', desc: 'Her an ulaşılabilir hat' },
  { icon: <FaTruck />, title: 'Yerinde Servis', desc: 'Adresinize hızlı geliş' },
  { icon: <FaShieldAlt />, title: 'Garantili İşçilik', desc: 'Güvenceli onarım' },
  { icon: <FaMapMarkedAlt />, title: 'Bursa Geneli', desc: 'Tüm ilçelere hizmet' },
];

const TrustStrip = () => {
  return (
    <section className="trust-strip" aria-label="Hizmet avantajları">
      <div className="trust-strip-inner">
        {items.map((item, i) => (
          <div className="trust-strip-item" key={i}>
            <span className="trust-strip-icon">{item.icon}</span>
            <div className="trust-strip-text">
              <p className="trust-strip-title">{item.title}</p>
              <p className="trust-strip-desc">{item.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default TrustStrip;
